const config = {
  api: {
    host: process.env.REACT_APP_API_DOMAIN,
  },
  layout: {
    wide: `(min-width: 730px)`,
  },
  report: {
    min_year: 2017,
  },
};

export default config;
